module.exports = __webpack_public_path__ + "static/media/holstee-manifesto.163a5e29.png";